<template>

  <ProductNavigation />
  
  <section class="banner full-width-section">

    <div class="banner-content">
      <div class="banner-navigation" v-if="slides[currentSlide]">
        <h1 class="main-title" v-html="slides[currentSlide].title"></h1>
        <p class="sub-title">{{ slides[currentSlide].subtitle }}</p>
      </div>
      <div class="banner-loading" v-else>
        <div class="loading-spinner"></div>
      </div>
      <div class="banner-carousel">
        <div class="carousel-slides" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
          <div class="carousel-slide" v-for="(slide, index) in slides" :key="index">
            <img :src="slide.src" :alt="slide.alt" class="banner-image">
          </div>
          <div class="carousel-slide" v-if="slides.length > 0">
            <img :src="slides[0].src" :alt="slides[0].alt" class="banner-image">
          </div>
        </div>
        <button class="carousel-control prev" @click="prevSlide"></button>
        <button class="carousel-control next" @click="nextSlide"></button>
        <div class="carousel-indicators">
          <span v-for="(slide, index) in slides" :key="index" @click="goToSlide(index)" :class="{ 'active': currentSlide === index || (currentSlide === slides.length && index === 0) }"></span>
        </div>
      </div>
    </div>
  </section>

  <section class="latest-product section-padding bg-gray-50 full-width-section">
    <div class="section-content">
      <h2 class="cn-title-product-new">{{ t('homepage.productCenter') }}</h2>
      <p class="en-title-product-new">{{ t('homepage.latestProduct') }}</p>
      <div class="product-list-container" ref="latestProductContainer">
        <div class="product-list animate">
          <div v-for="product in productList" :key="product.id" class="product-item" :class="{ 'highlighted': product.highlighted }" @click="goToProductDetail(product.id)">
            <div class="product-image-wrapper">
              <img :src="product.imageUrl" :alt="getProductTitle(product)" class="product-image">
            </div>
            <h4>{{ getProductTitle(product) }}</h4>
          </div>
        </div>
      </div>
      
      <div class="about-button-container">
        <a @click="goToProducts" class="about-button">
          {{ t('homepage.learnMore') }} &gt;
        </a>
      </div>
    </div>
  </section>

  <ChatBot />

  <section class="about-section section-padding bg-white full-width-section">
    <div class="section-content">
      <div class="about-content-container">
        <div class="about-text-content">
          <div class="company-profile">
            <h2 class="cn-title-product-new" style="color: black;">{{ $t('aboutPage.title') }}</h2>
            <span class="en-title-product-new">{{ $t('aboutPage.subtitle') }}</span>
            <p class="about-description">{{ aboutData?.description }}</p>
            <div class="about-button-container">
            <a href="/contact" class="about-button">{{ $t('aboutPage.learnMore') }} &gt;</a>
            </div>
          </div>
        </div>
        <div class="about-image-container">
          <img :src="getImageUrl(aboutData?.imageUrl)" :alt="$t('aboutPage.buildingAlt')" style="width: 100%; height: 100%; border-radius: 8px;">
        </div>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router';
import { getLatestProducts } from '@/api/product';
import { getBanners } from '@/api/banner';
import ChatBot from '@/components/ChatBot.vue';
import ProductNavigation from '@/components/ProductNavigation.vue';
import Footer from '@/components/Footer.vue';
import { getAboutData } from '@/api/about';
import axiosInstance from '@/api/axiosInstance';
import { useI18n } from 'vue-i18n';

export default {
  name: 'HomePage',
  components: {
    ChatBot,
    ProductNavigation,
    Footer
  },
  setup() {
    const { locale, t } = useI18n();
    const router = useRouter();
    const productList = ref([])
    const productImageContainer = ref(null);
    const latestProductContainer = ref(null);
    const slides = ref([]);
    const currentSlide = ref(0);
    const slideInterval = ref(null);
    const aboutData = ref({
      description: '关于我们描述',
      imageUrl: '/assets/about_us.png'
    });
    const newsList = ref([
      { title: '公司新闻标题1', date: '2023-10-01' },
      { title: '公司新闻标题2', date: '2023-09-15' },
      { title: '公司新闻标题3', date: '2023-08-20' }
    ]);
    const currentCategory = ref('all');
    const showCategory = ref(false);

    const getImageUrl = (imagePath) => {
      if (!imagePath) return '/assets/default-about-image.png';
      
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }
      
      if (imagePath.startsWith('/assets/')) {
        return imagePath;
      }
      
      if (imagePath.startsWith('uploads/')) {
        return `/assets/${imagePath}`;
      }
      
      if (imagePath.startsWith('/uploads/')) {
        return `/assets${imagePath}`;
      }
      
      return `${axiosInstance.defaults.baseURL}/${imagePath}`;
    };

   const loadBanners = async () => {
  try {
    const data = await getBanners();
    slides.value = data.filter(banner => banner.isActive);
    currentSlide.value = 0;
  } catch (error) {
    slides.value = [
      { src: '/assets/banner_pic.jpg', alt: '智能门机系统', id: 1 },
      { src: '/assets/banner_pic.jpg', alt: '互联网中间件', id: 2 }
    ];
    currentSlide.value = 0;
  }
};

    const loadProducts = async () => {
      try {
        const currentLang = locale.value === 'en' ? 'en' : 'zh';
        const response = await getLatestProducts(currentLang);
        if (response.data && Array.isArray(response.data)) {
          productList.value = response.data;
        } else {
          productList.value = [];
        }
      } catch (error) {
        productList.value = [];
      }
    };

  const loadAboutData = async () => {
    try {
      // 从API获取数据，传递当前语言参数
      const data = await getAboutData(locale.value);
      aboutData.value = {
        description: data.description || '',
        descriptionEn: data.descriptionEn || '',
        imageUrl: data.image_url || data.imageUrl || '/assets/default-about-image.png',
        storagePath: data.storage_path || ''
      };
      localStorage.setItem(`aboutData_${locale.value}`, JSON.stringify(data));
    } catch (error) {
      const savedData = localStorage.getItem(`aboutData_${locale.value}`);
      if (savedData) {
        const parsed = JSON.parse(savedData);
        aboutData.value = {
          description: parsed.description || '',
          descriptionEn: parsed.descriptionEn || '',
          imageUrl: parsed.image_url || parsed.imageUrl || '/assets/default-about-image.png',
          storagePath: parsed.storage_path || ''
        };
      } else {
        aboutData.value = {
          description: locale.value === 'en' ? 'Default company description' : '这是默认的公司描述',
          descriptionEn: '',
          imageUrl: '/assets/default-about-image.png'
        };
      }
    }
  };

    const handleAboutDataUpdate = () => {
      loadAboutData();
    };

    const nextSlide = () => {
      if (slides.value.length === 0) return;
      
      if (currentSlide.value === slides.value.length) {
        const slidesElement = document.querySelector('.carousel-slides');
        if (slidesElement) {
          slidesElement.style.transition = 'none';
        }
        currentSlide.value = 0;
        setTimeout(() => {
          if (slidesElement) {
            slidesElement.style.transition = '';
          }
          currentSlide.value = 1;
        }, 10);
      } else {
        currentSlide.value++;
      }
    };
    
    const prevSlide = () => {
      if (slides.value.length === 0) return;
      
      if (currentSlide.value === 0) {
        const slidesElement = document.querySelector('.carousel-slides');
        if (slidesElement) {
          slidesElement.style.transition = 'none';
        }
        currentSlide.value = slides.value.length;
        setTimeout(() => {
          if (slidesElement) {
            slidesElement.style.transition = '';
          }
          currentSlide.value = slides.value.length - 1;
        }, 10);
      } else {
        currentSlide.value--;
      }
    };
    
    const goToSlide = (index) => {
      currentSlide.value = index;
    };
    const startSlideInterval = () => {
      slideInterval.value = setInterval(nextSlide, 5000);
    };

    const stopSlideInterval = () => {
      if (slideInterval.value) {
        clearInterval(slideInterval.value);
        slideInterval.value = null;
      }
    };

    watch(locale, () => {
      loadProducts();
      loadAboutData();
    });

    onMounted(() => {
      loadProducts();
      loadBanners();
      loadAboutData();
      startSlideInterval();
      window.addEventListener('aboutDataUpdated', handleAboutDataUpdate);

      const observer = new IntersectionObserver(() => {
      }, {
        rootMargin: '0px 0px -50px 0px'
      });

      const productListObserver = new IntersectionObserver(() => {
      }, {
        rootMargin: '0px 0px -50px 0px'
      });

      if (productImageContainer.value) {
        observer.observe(productImageContainer.value);
      }
      if (latestProductContainer.value) {
        productListObserver.observe(latestProductContainer.value);
      }
    });

    onUnmounted(() => {
      stopSlideInterval();
      window.removeEventListener('aboutDataUpdated', handleAboutDataUpdate);
    });

    const goToProducts = () => {
      router.push({ name: 'Products' });
    };

    const goToProductDetail = (productId) => {
      router.push({ name: 'ProductDetail', params: { id: productId } });
    };

    const handleImageUpload = () => {
    };

    const getProductTitle = (product) => {
      if (!product) return '';
      
      let title = product.title || '';
      
      if (locale.value === 'en') {
        if (/[\u4e00-\u9fa5]/.test(title)) {
          if (product.titleEn && product.titleEn.trim() !== '') {
            title = product.titleEn;
          }
        }
      } else {
        if (!/[\u4e00-\u9fa5]/.test(title) && /^[A-Za-z0-9\s\-.,()]+$/.test(title)) {
          title = product.titleZh || title;
        }
      }
      
      return title;
    };

    return {
      slides,
      currentSlide,
      nextSlide,
      prevSlide,
      goToSlide,
      goToProducts,
      newsList,
      latestProductContainer,
      currentCategory,
      showCategory,
      productList,
      loadProducts,
      goToProductDetail,
      aboutData,
      handleImageUpload,
      getImageUrl,
      getProductTitle,
      locale,
      t
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/sections/homepage/banner";
@import "@/styles/sections/homepage/latest_product";
@import "@/styles/sections/homepage/about_section";
@import "@/styles/sections/homepage/customer_service";
@import "@/styles/sections/homepage/main_menu";
@import '@/styles/sections/homepage/global_style.scss';


.advantage-container {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 2rem 0;
}

.advantage-logo {
  flex: 0 0 200px; /* 固定宽度 */
}

.advantage-columns {
  flex: 1; /* 占据剩余空间 */
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.logo-container {
  display: flex;
  align-items: center;
  height: 100%;
}

/* 重置页面默认边距 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 基础样式 */
.app-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.ad-section {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

/* 重置默认样式，简化布局调试 */
* {
      margin: 0; 
      padding: 0; 
      box-sizing: border-box;
    }

    body {
      margin: 0;
      padding: 0;
      font-family: "Helvetica Neue", Arial, sans-serif;
      background-color: #fff;
      color: #333;
    }


    .full-width-section {
  width: 100vw;
  position: relative;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
}

.advantages {
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  line-height: 0; /* 消除行高影响 */
}

/* 图片样式 - 确保无间隙 */
.advantages-image {
  display: block; /* 转换为块级元素，消除基线对齐间隙 */
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  object-fit: cover;
}

    .advantage-logo img {
        width: 200px; /* 根据实际图片大小调整 */
        margin-bottom: 20px;
    }

    .advantage-columns {
        display: flex;
        gap: 20px;
    }

    .advantage-item {
        text-align: center;
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease;
    }

    .advantage-item:hover {
        transform: translateY(-5px);
    }

    .advantage-icon img {
        width: 50px; /* 根据实际图标大小调整 */
        margin-bottom: 10px;
    }
    .carousel-slides {
      display: flex;
      transition: transform 0.5s ease-in-out; // 确保有过渡效果
    }

    .carousel-slide {
      width: 100%;
      flex-shrink: 0;
    }

    h2 {
        margin-bottom: 20px;
    }

    h3 {
        margin: 10px 0;
        font-size: 18px;
    }

    p {
        color: #666;
    }
    /* 响应式布局适配 - 手机端 */
@media (max-width: 768px) {
  /* 优势展示区域响应式调整 */
  .advantage-container {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    margin: 1.5rem 0;
  }
  
  .advantage-logo {
    flex: 0 0 auto;
    width: 150px;
    margin: 0 auto;
  }
  
  .advantage-columns {
    flex-direction: column;
    gap: 1rem;
  }
  
  .advantage-item {
    padding: 15px;
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }
  
  /* 基础容器响应式调整 */
  .app-container {
    padding: 0 15px;
  }
  
  /* 全宽区域响应式处理 */
  .full-width-section {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    position: relative;
  }
  
  /* 图片响应式处理 */
  .advantages-image {
    width: 100%;
    height: auto;
  }
  
  /* 字体大小响应式调整 */
  h2 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  h3 {
    font-size: 16px;
    margin: 8px 0;
  }
  
  p {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  /* 小屏手机进一步优化 */
  .advantage-container {
    gap: 1rem;
    margin: 1rem 0;
  }
  
  .advantage-logo {
    width: 120px;
  }
  
  .advantage-logo img {
    width: 120px;
    margin-bottom: 15px;
  }
  
  .advantage-item {
    padding: 12px;
  }
  
  .advantage-icon img {
    width: 40px;
    margin-bottom: 8px;
  }
  
  /* 更小屏幕的字体优化 */
  h2 {
    font-size: 20px;
    margin-bottom: 12px;
  }
  
  h3 {
    font-size: 14px;
  }
  
  p {
    font-size: 13px;
  }
}

@media (max-width: 360px) {
  /* 极小屏幕优化 */
  .advantage-item {
    padding: 10px;
  }
  
  .advantage-logo {
    width: 100px;
  }
  
  .advantage-logo img {
    width: 100px;
  }
  
  h2 {
    font-size: 18px;
  }
}

/* 通用移动设备触摸优化 */
@media (hover: none) and (pointer: coarse) {
  .advantage-item {
    /* 针对触摸设备优化，移除悬停效果的依赖 */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .advantage-item:active {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
}

</style>
